<template>
    <v-data-table
        :headers="headers"
        :items="regions"
        :items-per-page="5"
        class="elevation-1"
    >
        <template v-slot:item="{ item }">
            <tr @contextmenu.prevent="openContextMenu($event, item)">
                <td>
                    <div>{{ item.id }}</div>
                </td>
                <td>
                    <v-edit-dialog :return-value.sync="item.name" large @save="saveItem(item)">
                        <div>{{ item.name }}</div>
                        <template v-slot:input>
                            <v-text-field v-model="item.name" label="Name" single-line></v-text-field>
                        </template>
                    </v-edit-dialog>
                </td>
                <td>
                    <v-edit-dialog :return-value.sync="item.rate" large @save="saveItem(item)">
                        <div>{{ item.rate }}</div>
                        <template v-slot:input>
                            <v-text-field v-model="item.rate" label="Rate" single-line></v-text-field>
                        </template>
                    </v-edit-dialog>
                </td>
                <td>
                    <v-edit-dialog :return-value.sync="item.status" large @save="saveItem(item)">
                        <div>{{ item.status }}</div>
                        <template v-slot:input>
                            <v-select v-model="item.status" :items="['ACTIVE', 'INACTIVE']" label="Status"></v-select>
                        </template>
                    </v-edit-dialog>
                </td>
                <td>
                    <v-edit-dialog :return-value.sync="item.province_abbr" large @save="saveItem(item)">
                        <div>{{ item.province_abbr }}</div>
                        <template v-slot:input>
                            <v-text-field v-model="item.province_abbr" label="Province Abbr" single-line></v-text-field>
                        </template>
                    </v-edit-dialog>
                </td>
            </tr>
        </template>
    </v-data-table>
</template>

<script>
import axios from 'axios';

export default {
    name: 'TaxRegions',
    props: {
        regions: Array,
        headers: Array
    },
    data: () => ({
        form: {
            name: '',
            rate: '',
            province_abbr: '',
            status: 'ACTIVE'
        }
    }),
    methods: {
        saveItem(item) {
            console.log('From save item');
            console.log(item);
            this.form = { ...item };
            this.update();
        },
        update() {
            // Update the form
            console.log('Form is valid');
            axios
                .put('v2/maintenance/tax/region/' + this.form.id, this.form)
                .then(response => {
                    console.log(response.data);
                    
                    this.$store.dispatch('setSnackbar', {
                        text: 'Tax region updated',
                        color: 'success'
                    });
                    
                    this.$emit('update');
                })
                .catch(error => {
                    console.log(error);
                    
                    this.$store.dispatch('setSnackbar', {
                        text: 'Error updating tax region',
                        color: 'error'
                    });
                });
        },
        openContextMenu(event, item) {
            item = { ...item, catalogKey: 'taxRegions' };
            this.$emit('open-context-menu', { event, item });
        },
    }
};
</script>
